<template>
    <div>
      <Form ref="resourceApplicationForm" :model="resourceApplicationForm" :label-width="150">
        <Row>
            <Col span="11">
            <FormItem :label="$t( 'resourceLifecycle.name' )">
                <Input v-model="resourceApplicationForm.name" :placeholder="$t( 'resourceLifecycle.pleaseenter' )"/>
            </FormItem>
            </Col>
            <Col span="11">
            <FormItem prop="enableTerminationProtection" :label="$t( 'resourceLifecycle.enableTerminationProtection' )">
                <Select v-model="resourceApplicationForm.enableTerminationProtection" filterable>
                    <Option :value="item.label" v-for="(item,index) in enableTerminationProtectionList"
                            :key="index">{{item.name}}</Option>
                </Select>
            </FormItem>
            </Col>
        </Row>

        <Row>
            <Col span="11">
            <FormItem prop="numberOfInstances" :label="$t( 'resourceLifecycle.numberofinstances' )">
                <InputNumber v-model="resourceApplicationForm.numberOfInstances" @on-change="queryAWSInstancePrice"
                             style="width: 100%;"></InputNumber>
            </FormItem>
            </Col>
            <Col span="11">
            <FormItem prop="keyName" :label="$t( 'resourceLifecycle.keypair' )">
                <Select v-model="resourceApplicationForm.keyName" filterable>
                    <Option :value="item.keyName" v-for="item in keyPairInfoList" v-bind:key="item.keyName">{{item.keyName}}</Option>
                </Select>
            </FormItem>
            </Col>
        </Row>

        <Row>
            <Col span="11">
            <FormItem prop="monitor" :label="$t( 'resourceLifecycle.surveillance' )">
                <Select v-model="resourceApplicationForm.monitor" filterable>
                    <Option :value="item.label" v-for="(item,index) in monitorList" :key="index">{{item.name}}</Option>
                </Select>
            </FormItem>
            </Col>
        </Row>

        <Row>
            <Col span="11">
            <FormItem prop="vpc" :label="$t( 'resourceLifecycle.webs' )">
                <Select v-model="resourceApplicationForm.vpc" filterable @on-change="changeVpc">
                    <Option :value="item.vpcId" v-for="(item,index) in vpcList" v-bind:key="item.vpcId">{{item.vpcId+"("+item.name+")"}}</Option>
                </Select>
            </FormItem>
            </Col>
            <Col span="11">
            <FormItem prop="subnet" :label="$t( 'resourceLifecycle.subnet' )">
                <Select v-model="resourceApplicationForm.subnet" filterable>
                    <Option :value="item.subnetId" v-for="item in subnetList" v-bind:key="item.subnetId">{{item.name}}</Option>
                </Select>
            </FormItem>
            </Col>
        </Row>

        <Row>
            <Col span="11">
            <FormItem prop="securityGroup" :label="$t( 'resourceLifecycle.securityGroup' )">
                <Select v-model="resourceApplicationForm.securityGroup" filterable>
                    <Option :value="item.groupId" v-for="(item,index) in securityGroupList" v-bind:key="item.groupId">{{item.groupName}}</Option>
                </Select>
            </FormItem>
            </Col>
            <Col span="11">
            <FormItem prop="automaticallyAssignPublicIP"
                      :label="$t( 'resourceLifecycle.automaticdistributionofpublicIP' )">
                <Select v-model="resourceApplicationForm.automaticallyAssignPublicIP" filterable>
                    <Option :value="item.label" v-for="(item,index) in automaticallyAssignPublicIPList" :key="index">{{item.name}}</Option>
                </Select>
            </FormItem>
            </Col>
        </Row>

        <!-- 磁盘 -->
        <Row>
            <Col span="22">
            <Row style="margin-bottom: 10px;">
                <Col>
                <Button @click="addVolume" style="float: right;">{{$t('resourceLifecycle.add')}}</Button>
                </Col>
            </Row>
            <FormItem :label="$t( 'resourceLifecycle.disks' )">
                <Table :no-data-text="$t('common.noData')" :columns="volumeColumns" :data="awsVolumeList"
                       style="margin-bottom: 10px;">
                    <template slot-scope="{row,index}" slot="delete">
                        <Button type="error" size="small" @click="removeVolume(index)">
                            {{$t('resourceLifecycle.delete')}}
                        </Button>
                    </template>
                </Table>
            </FormItem>
            </Col>
        </Row>

        <Row>
            <Col span="11">
            <FormItem prop="calculationSpecifications" :label="$t( 'resourceLifecycle.calculationSpecifications' )">
                <Select v-model="resourceApplicationForm.calculationSpecifications" filterable
                        @on-change="selectEc2PriceByInstanceTypeName()">
                    <Option :value="item" v-for="(item,index) in calculationSpecificationsList" v-bind:key="item">{{item}}</Option>
                </Select>
            </FormItem>
            </Col>
        </Row>

        <Row>
            <Col span="22">
            <FormItem :label="$t( 'resourceLifecycle.cloudPlatformSpecifications' )">
                <Table :columns="columns" :data="cloudPlatformSpecificationsDate"></Table>
            </FormItem>
            </Col>
        </Row>

        <!-- 镜像 -->
        <Row>
            <Col span="22">
            <FormItem :label="$t( 'resourceLifecycle.operatingsystem' )">
                <Row :gutter="10">
                    <Col span="11">
                    <FormItem prop="os">
                        <Select v-model="resourceApplicationForm.os" filterable @on-change="queryMirrorImageName">
                            <Option :value="item" v-for="(item,index) in osList" v-bind:key="item">{{item}}</Option>
                        </Select>
                    </FormItem>
                    </Col>
                    <Col span="11">
                    <FormItem prop="mirror">
                        <Select v-model="resourceApplicationForm.mirror" filterable @on-change="queryAWSInstancePrice()">
                            <Option :value="item" v-for="(item,index) in mirrorList" v-bind:key="item">{{item}}</Option>
                        </Select>
                    </FormItem>
                    </Col>
                </Row>
            </FormItem>
            </Col>
        </Row>

        <Row>
            <Col span="22">
            <FormItem :label="$t( 'resourceLifecycle.tags' )">
                <Row :gutter="10">
                    <Col span="11">
                    <label>{{$t('resourceLifecycle.keyupto128characters')}}</label></Col>
                    <Col span="11">
                    <label>{{$t('resourceLifecycle.valueupto256characters')}}</label></Col>
                </Row>
                <FormItem v-for="(tag,index) in resourceApplicationForm.tags" :key="index">
                    <Row :gutter="10">
                        <Col span="11" style="margin-bottom: 20px;">
                          <FormItem :prop="'tags.' + index + '.key'"
                                    :rules="{type: 'string',pattern:'^(?!Name$)' ,message: '键名不能为Name', trigger: 'blur'}">
                            <Input type="text" v-model="tag.key"></Input>
                        </FormItem>
                        </Col>
                        <Col span="11">
                        <FormItem>
                            <Input type="text" v-model="tag.value"></Input>
                        </FormItem>
                        </Col>
                        <Col span="2">
                        <Button @click="handleRemoveTag(index)">{{$t('resourceLifecycle.delete')}}</Button>
                        </Col>
                    </Row>
                </FormItem>
                <Row>
                    <Col span="22">
                    <Button type="dashed" long @click="handleAdd" icon="md-add">{{$t('resourceLifecycle.addTag')}}
                    </Button>
                    </Col>
                </Row>
            </FormItem>
            </Col>
        </Row>
      </Form>
    </div>
</template>

<script>

export default {
  name: 'AmazonVirtualMachine',
  props: ['amazonResourceApplicationBasicInfoForm', 'cost', 'allUpfrontOneYearPrice','noUpfrontOneYearPrice'],
  components: {},
  data() {
    return {
      currentChoose: 0,
      modal_loadings: false,
      addloading: false,
      enableTerminationProtectionList: [{
        label: 'true',
        name: this.$t('resourceLifecycle.yes')
      }, {
        label: 'false',
        name: this.$t('resourceLifecycle.no')
      }],
      monitorList: [{
        label: 'true',
        name: this.$t('resourceLifecycle.yes')
      }, {
        label: 'false',
        name: this.$t('resourceLifecycle.no')
      }],
      keyPairInfoList: [],
      osList: [],
      calculationSpecificationsList: [],
      mirrorList: [],
      subnetList: [],
      vpcList: [],
      securityGroupList: [],
      automaticallyAssignPublicIPList: [{
        label: 'true',
        name: this.$t('resourceLifecycle.yes')
      }, {
        label: 'false',
        name: this.$t('resourceLifecycle.no')
      }],
      resourceApplicationForm: {
        name: '',
        enableTerminationProtection: 'true',
        numberOfInstances: 1,
        keyName: '',
        monitor: 'true',
        calculationSpecifications: '',
        instanceType: '',
        cpu: 0,
        ram: 0,
        os: '',
        mirror: '',
        subnet: '',
        vpc: '',
        automaticallyAssignPublicIP: 'true',
        securityGroup: '',
        cost: 0,
        allUpfrontOneYearPrice: 0,
        noUpfrontOneYearPrice: 0,
        tags: [{
          key: '',
          value: ''
        }]
      },
      ruleValidate: {
        name: [
          {required: true, message: this.$t('resourceLifecycle.namecannotbeempty'), trigger: 'blur'}
        ],
        enableTerminationProtection: [
          {
            required: true,
            message: this.$t('resourceLifecycle.pleaseselectEnableTerminationProtection'),
            trigger: 'change'
          }
        ],
        numberOfInstances: [
          {
            required: true,
            message: this.$t('resourceLifecycle.pleaseenterthenumberofinstances'),
            trigger: 'blur',
            type: 'number'
          }
        ],
        keyName: [
          {required: true, message: this.$t('resourceLifecycle.pleaseselectakeypair'), trigger: 'change'}
        ],
        monitor: [
          {required: true, message: this.$t('resourceLifecycle.pleaseselectMonitoring'), trigger: 'change'}
        ],
        calculationSpecifications: [
          {
            required: true,
            message: this.$t('resourceLifecycle.pleaseselectCalculationSpecification'),
            trigger: 'change'
          }
        ],
        os: [
          {required: true, message: this.$t('resourceLifecycle.pleaseselecttheoperatingsystem'), trigger: 'change'}
        ],
        mirror: [
          {required: true, message: this.$t('resourceLifecycle.pleaseselectamirror'), trigger: 'change'}
        ],
        subnet: [
          {required: true, message: this.$t('resourceLifecycle.pleaseselectsubnet'), trigger: 'change'}
        ],
        vpc: [
          {required: true, message: this.$t('resourceLifecycle.pleaseselectnetwork'), trigger: 'change'}
        ],
        automaticallyAssignPublicIP: [
          {required: true, message: this.$t('resourceLifecycle.pleaseselectAuto-AssignPublicIP'), trigger: 'change'}
        ],
        securityGroup: [
          {required: true, message: this.$t('resourceLifecycle.pleaseselectasecuritygroup'), trigger: 'change'}
        ]
      },
      columns: [
        {
          title: this.$t('resourceLifecycle.selects'),
          key: 'instanceType',
          width: 70,
          align: 'center',
          render: (h, params) => {
            let instanceType = params.row.instanceType;
            let cpu = params.row.cpuCoreNumber;
            let ram = params.row.ramSize;
            let flag = false;
            if (this.resourceApplicationForm.instanceType === instanceType) {
              flag = true
            } else {
              flag = false
            }
            let self = this
            return h('div', [
              h('Radio', {
                props: {
                  value: flag
                },
                on: {
                  'on-change': () => {
                    self.resourceApplicationForm.instanceType = instanceType;
                    self.resourceApplicationForm.cpu = cpu;
                    self.resourceApplicationForm.ram = ram;
                    self.queryAWSInstancePrice();
                  }
                }
              })
            ])
          }
        },
        {
          title: this.$t('resourceLifecycle.models'),
          key: 'instanceType'
        },
        {
          title: this.$t('resourceLifecycle.numberofCPUcores'),
          key: 'cpuCoreNumber'
        },
        {
          title: this.$t('resourceLifecycle.memoryGB'),
          key: 'ramSize'
        }],
      cloudPlatformSpecificationsDate: [],
      volumeColumns: [
        {
          title: this.$t('resourceLifecycle.volumeType'),
          key: 'volumeType',
          render: (h, params) => {
            let $volumeTypeList = this.volumeTypeList
            let self = this
            return h('Select', {
                props: {
                  value: self.awsVolumeList[params.index].volumeType,
                  transfer: true
                },
                on: {
                  'on-change': (event) => {
                    self.awsVolumeList[params.index].volumeType = event
                    self.queryAWSInstancePrice();
                  }
                }
              },
              $volumeTypeList.map(function (item) {
                return [
                  h('Option', {
                    props: {
                      value: item.id
                    }
                  }, item.name)
                ]
              }))
          }
        },
        {
          title: this.$t('resourceLifecycle.availabilityZones'),
          key: 'availabilityZone',
          render: (h, params) => {
            let $availabilityZoneList = this.availabilityZoneList
            let self = this
            return h('Select', {
                props: {
                  value: self.awsVolumeList[params.index].availabilityZone,
                  transfer: true
                },
                on: {
                  'on-change': (event) => {
                    self.awsVolumeList[params.index].availabilityZone = event
                  }
                }
              },
              $availabilityZoneList.map(function (item) {
                return [
                  h('Option', {
                    props: {
                      value: item.zoneName
                    }
                  }, item.zoneName)
                ]
              }))
          }
        },
        {
          title: this.$t('resourceLifecycle.sizeGiB'),
          key: 'size',
          render: (h, params) => {
            let self = this
            return h('InputNumber', {
              attrs: {
                value: params.row.size,
                "min": 40,
                "max": 32768,
                activeChange: false
              },
              on: {
                'on-change': function (event) {
                  self.awsVolumeList[params.index].size = event
                  self.queryAWSInstancePrice();
                }
              }
            })
          }
        },
        {
          title: 'IOPS',
          key: 'IOPS',
          render: (h, params) => {
            let self = this
            return h('InputNumber', {
              attrs: {
                value: params.row.IOPS,
                "min": 40,
                "max": 32768,
                activeChange: false
              },
              on: {
                'on-change': function (event) {
                  self.awsVolumeList[params.index].IOPS = event
                  self.queryAWSInstancePrice();
                }
              }
            })
          }
        },
        {
          title: this.$t('resourceLifecycle.whethertoencrypt'),
          key: 'isEncryption',
          render: (h, params) => {
            let self = this
            return h('Checkbox', {
              props: {
                value: params.row.isEncryption
              },
              on: {
                'on-change': function (event) {
                  self.awsVolumeList[params.index].isEncryption = event
                }
              }
            })
          }
        },
        {
          title: this.$t('resourceLifecycle.operations'),
          slot: 'delete'
        }],
      awsVolumeList: [],
      availabilityZoneList: [],
      volumeTypeList: []
    }
  },
  mounted: function () {
  },
  methods: {
    showAll: function () {
      //查询密钥对
      this.queryAWSKeyPairList();
      //查询网络
      this.queryAWSVpcList();
      //查询aws磁盘类型
      this.queryAWSVolumeType();
      //查询AWS可用区
      this.queryAWSAvailableZoneList();
      //查询AWS计算规格
      this.listCalculationSpecification();
      //查询AWS系统
      this.querySystem();
    },
    //查询RI价格
    queryReservedInstancesPrice: function () {
      // 账号
      if (this.StringUtils.isEmpty(this.amazonResourceApplicationBasicInfoForm.accountId)) {
        return;
      }
      // 区域
      if (this.StringUtils.isEmpty(this.amazonResourceApplicationBasicInfoForm.region)) {
        return;
      }
      // 操作系统
      if (this.StringUtils.isEmpty(this.resourceApplicationForm.os)) {
        return;
      }
      // 实例类型
      if (this.StringUtils.isEmpty(this.resourceApplicationForm.instanceType)) {
        return;
      }
      // 实例数量
      if (this.StringUtils.isEmpty(this.resourceApplicationForm.numberOfInstances)) {
        return;
      }
      // 使用期限
      if (this.StringUtils.isEmpty(this.amazonResourceApplicationBasicInfoForm.periodOfUse)) {
        return;
      }
      let lifecycleResourceRequestDTO = {
        "accountId": this.amazonResourceApplicationBasicInfoForm.accountId,
        "region": this.amazonResourceApplicationBasicInfoForm.region,
        "osType": this.resourceApplicationForm.os,
        "duration": this.amazonResourceApplicationBasicInfoForm.periodOfUse,
        "lifecycleResourceInstanceDTO": {
          "instanceType": this.resourceApplicationForm.instanceType,
          "instanceNumber": this.resourceApplicationForm.numberOfInstances
        }
      };
      this.$api.lifecycleResourceApplication.queryReservedInstancesPrice(lifecycleResourceRequestDTO)
        .then(res => {
          // 一年价格 预付全款
          this.$emit('getAllUpfrontOneYearPrice', res.data.allUpfrontOneYearPrice);
          // 一年价格 无预付费用
          this.$emit('getNoUpfrontOneYearPrice', res.data.noUpfrontOneYearPrice);
        })
    },
    // 查询资源价格
    queryResourcePrice: function () {

      var submitLifecycleResourceApplicationDTO = {
        "osType": this.resourceApplicationForm.mirror,
        "duration": this.amazonResourceApplicationBasicInfoForm.periodOfUse,
        "region": this.amazonResourceApplicationBasicInfoForm.region,
        "lifecycleResourceInstanceDTO": {
          "instanceType": this.resourceApplicationForm.instanceType,
          "cpu": this.resourceApplicationForm.cpu,
          "ram": this.resourceApplicationForm.ram,
          "instanceNumber": this.resourceApplicationForm.numberOfInstances
        }
      }
      // AWS 磁盘
      submitLifecycleResourceApplicationDTO.lifecycleResourceVolumeDTOS = []
      var awsVolumeList = this.awsVolumeList
      for (var i = 0; i < awsVolumeList.length; i++) {
        var lifecycleResourceVolumeDTO = {
          "accountId": this.resourceApplicationForm.accountId,
          "region": this.resourceApplicationForm.region,
          "awsZone": awsVolumeList[i].availabilityZone,
          "encrypted": awsVolumeList[i].isEncryption,
          "type": awsVolumeList[i].volumeType,
          "capacity": awsVolumeList[i].size,
          "iops": awsVolumeList[i].IOPS,
        }
        submitLifecycleResourceApplicationDTO.lifecycleResourceVolumeDTOS.push(lifecycleResourceVolumeDTO)
      }
      this.$api.awsPrice.queryAWSInstancePrice(submitLifecycleResourceApplicationDTO)
        .then(res => {
          this.resourceApplicationForm.cost = res.data
          this.$emit('success', this.resourceApplicationForm.cost);
        })
    },
    //查询价格
    queryAWSInstancePrice: function () {
      // 查询RI价格
      this.queryReservedInstancesPrice();
      // 查询资源价格
      this.queryResourcePrice();
    },
    //查询密钥对
    queryAWSKeyPairList: function () {
      this.$api.lifecycleResourceApplication.queryAWSKeyPairList({
        "accountId": this.amazonResourceApplicationBasicInfoForm.accountId,
        "region": this.amazonResourceApplicationBasicInfoForm.region
      })
        .then(res => {
          this.keyPairInfoList = res.data;
          this.resourceApplicationForm.keyName = this.keyPairInfoList[0].keyName
        })
    },
    //查询网络
    queryAWSVpcList: function () {
      this.$api.lifecycleResourceApplication.queryAWSVpcList({
        "accountId": this.amazonResourceApplicationBasicInfoForm.accountId,
        "region": this.amazonResourceApplicationBasicInfoForm.region
      })
        .then(res => {
          this.vpcList = res.data;
          this.resourceApplicationForm.vpc = this.vpcList[0].vpcId
          this.changeVpc();
        })
    },
    changeVpc: function () {
      //查询子网
      this.queryAWSSubnetList();
      //查询安全组
      this.queryAWSSecurityGroupList();
    },
    //查询子网
    queryAWSSubnetList: function () {
      this.$api.lifecycleResourceApplication.queryAWSSubnetList({
        "accountId": this.amazonResourceApplicationBasicInfoForm.accountId,
        "region": this.amazonResourceApplicationBasicInfoForm.region,
        "vpc": this.resourceApplicationForm.vpc
      })
        .then(res => {
          this.subnetList = res.data;
          this.resourceApplicationForm.subnet = this.subnetList[0].subnetId
        })
    },
    //查询安全组
    queryAWSSecurityGroupList: function () {
      this.$api.lifecycleResourceApplication.queryAWSSecurityGroupList({
        "accountId": this.amazonResourceApplicationBasicInfoForm.accountId,
        "region": this.amazonResourceApplicationBasicInfoForm.region,
        "vpc": this.resourceApplicationForm.vpc
      })
        .then(res => {
          this.securityGroupList = res.data;
          this.resourceApplicationForm.securityGroup = this.securityGroupList[0].groupId
        })
    },
    //查询aws磁盘类型
    queryAWSVolumeType: function () {
      this.$api.lifecycleResourceApplication.queryAWSVolumeType()
        .then(res => {
          this.volumeTypeList = res.data;
        })
    },
    //查询AWS可用区
    queryAWSAvailableZoneList: function () {
      this.$api.lifecycleResourceApplication.queryAWSAvailableZoneList({
        "accountId": this.amazonResourceApplicationBasicInfoForm.accountId,
        "region": this.amazonResourceApplicationBasicInfoForm.region
      })
        .then(res => {
          this.availabilityZoneList = res.data;
        })
    },
    //查询AWS计算规格
    listCalculationSpecification: function () {
      this.$api.price.listCalculationSpecification({
        "region": this.amazonResourceApplicationBasicInfoForm.region
      })
        .then(res => {
          this.calculationSpecificationsList = res.data;
          this.resourceApplicationForm.calculationSpecifications = this.calculationSpecificationsList[0]
          this.selectEc2PriceByInstanceTypeName();
        })
    },
    //查询AWS云平台规格
    selectEc2PriceByInstanceTypeName: function () {
      this.$api.price.selectEc2PriceByInstanceTypeName({
        "instanceSpecification": this.resourceApplicationForm.calculationSpecifications,
        "region": this.amazonResourceApplicationBasicInfoForm.region
      })
        .then(res => {
          this.cloudPlatformSpecificationsDate = res.data;
          this.queryAWSInstancePrice();
        })
    },
    //查询AWS镜像名称
    queryMirrorImageName: function () {
      this.$api.price.queryMirrorImageName({
        "system": this.resourceApplicationForm.os
      })
        .then(res => {
          this.mirrorList = res.data;
          this.resourceApplicationForm.mirror = this.mirrorList[0]
          //查询价格
          this.queryAWSInstancePrice();
        })
    },
    //查询AWS系统
    querySystem: function () {
      this.$api.price.querySystem()
        .then(res => {
          this.osList = res.data;
          this.resourceApplicationForm.os = this.osList[0]
          this.queryMirrorImageName();
        })
    },
    /********************磁盘********************************/
    // 添加
    addVolume: function () {
      this.awsVolumeList.push({
        volumeType: 0,
        availabilityZone: '',
        size: 100,
        IOPS: 100,
        isEncryption: false
      })
      this.queryAWSInstancePrice();
    },
    // 删除
    removeVolume(index) {
      this.awsVolumeList.splice(index, 1);
      this.queryAWSInstancePrice();
    },
    /*********************标签***********************************/
    handleAdd() {
      this.resourceApplicationForm.tags.push({
        value: '',
        key: ''
      })
    },
    handleRemoveTag(index) {
      if (this.resourceApplicationForm.tags.length === 1) {
        this.$Message.warning(this.$t('resourceLifecycle.atleastonesubdimensionisrequired'))
        return
      }
      this.resourceApplicationForm.tags.splice(index, 1)
    },
  }
}
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_application/aws/virtual_machine/AmazonVirtualMachine.vue